
window.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('expMainForm');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const step4Fields = document.querySelectorAll('.exp-form-step-4 input:not([data-optional]), .exp-form-step-4 select:not([data-optional])');
    const hasEmptyFields = [...step4Fields].some(field => field.value.trim() === '');
    if (hasEmptyFields) return showStep4Error('exp-form-error-message-empty');

    const formValues = {
      name: '',
      email: '',
      type: '',
      code: '',
    };

    const formData = new FormData(form);
    formData.forEach((value, key) => {
      formValues[key] = value;
    });

    const registerResponse = await fetch('/apps/proxy/caffeine-experts/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formValues),
    })
      .then((data) => data.json())
      .catch((err) => console.log(err));

    if (registerResponse.data.status != 200 && registerResponse.data?.errors?.email != null) {
      return showErrorOnEmail()
    } else if (registerResponse.data.status != 200) {
      return showStep4Error('exp-form-error-message-register')
    }
    return setExpFormStep(5)
  });

  const dateInput = document.getElementById('data-nascimento');
  const currentValue = document.getElementById('currentValue');

  dateInput.addEventListener('input', function (e) {
    let value = e.target.value;
    value = value.replace(/\D/g, '');

    if (value.length >= 3 && value.length <= 4) {
      value = value.replace(/(\d{2})(\d+)/, '$1/$2');
    } else if (value.length >= 5) {
      value = value.replace(/(\d{2})(\d{2})(\d+)/, '$1/$2/$3');
    }

    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    e.target.value = value;
    currentValue.textContent = value || '-';
  });

  dateInput.addEventListener('keydown', function (e) {
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight'];

    if (allowedKeys.includes(e.key) ||
      (e.key >= '0' && e.key <= '9') ||
      (e.ctrlKey && (e.key === 'a' || e.key === 'c' || e.key === 'v' || e.key === 'x'))) {
      return;
    }

    e.preventDefault();
  });

  dateInput.addEventListener('paste', function (e) {
    setTimeout(() => {
      let value = e.target.value.replace(/\D/g, '');

      if (value.length >= 3 && value.length <= 4) {
        value = value.replace(/(\d{2})(\d+)/, '$1/$2');
      } else if (value.length >= 5) {
        value = value.replace(/(\d{2})(\d{2})(\d+)/, '$1/$2/$3');
      }

      if (value.length > 10) {
        value = value.substring(0, 10);
      }

      e.target.value = value;
      currentValue.textContent = value || '-';
    }, 10);
  });
});

async function validateRegister() {
  const submitContainer = document.getElementById('professionalValidationStep')
  const previousContent = submitContainer.innerHTML;
  submitContainer.innerHTML = `
    <div class="exp-load-container">
        <div class="loading-dots">
          <span class="loading-dot"></span>
          <span class="loading-dot"></span>
          <span class="loading-dot"></span>
      </div>
      <p>Aguarde um momento enquanto validamos os seus dados</p>
    </div>
    `
  const registerValidation = document.getElementById('expMainForm');

  const allFormValues = {
    name: '',
    type: '',
    code: '',
    uf: '',
  };

  const currentFormData = new FormData(registerValidation);
  currentFormData.forEach((value, key) => {
    allFormValues[key] = value;
  });

  const hasValidRegister = await fetch('/apps/proxy/caffeine-experts/validate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(allFormValues),
  })
    .then((data) => data.json())
    .catch((err) => console.log(err));

  await new Promise((resolve) => {
    setTimeout(() => {
      submitContainer.innerHTML = previousContent;
      resolve();
    }, 1500);
  });
  return hasValidRegister;
}

async function handleValidateRegister() {
  const registerValidation = await validateRegister();

  if (registerValidation.data.isValidRegister) {
    validateFormStep(3)
  } else {
    showErrorBox(3)
  }
}

function defineFormType(type) {
  const typeInput = document.getElementById('expertType')
  if (typeInput) typeInput.value = type;

  setExpFormStep(2)

}

function setExpFormStep(number) {
  const expFormSteps = document.querySelectorAll('.exp-form-content')
  expFormSteps.forEach((step) => step.classList.add('hidden-block'))

  const currentStep = document.querySelector(`.exp-form-step-${number}`)
  if (currentStep) currentStep.classList.remove('hidden-block')

  const progressSection = document.querySelector('.exp-form-progress-section');
  if (progressSection) progressSection.classList.remove('hidden-block');

  const stepIndicator = document.querySelector('.exp-step-indicator');
  if (stepIndicator) stepIndicator.textContent = number;

  const stepPercentage = (number) * 20;
  const progressFill = document.querySelector('.exp-form-progress-fill');
  if (progressFill) progressFill.style.width = `${stepPercentage}%`;
}

function validateFormStep(number) {
  const stepInputs = document.querySelectorAll(`.exp-form-step-${number} input`);
  let noEmptyFields = true;

  stepInputs.forEach(input => {
    if (input.value.trim() === '') {
      noEmptyFields = false;
    }
  });

  if (noEmptyFields) {
    setExpFormStep(number + 1);
  } else {
    showErrorBox(number)
  }
}

function showErrorBox(number) {
  const stepError = document.querySelector(`.exp-form-step-${number} .exp-form-error-message`);
  stepError.classList.remove('hidden-block');
  setTimeout(() => {
    stepError.classList.add('hidden-block');
  }, 6000);
}

function showStep4Error(errorClass) {
  const stepError = document.querySelector(`.exp-form-step-4 .${errorClass}`);
  stepError.classList.remove('hidden-block');
  setTimeout(() => {
    stepError.classList.add('hidden-block');
  }, 6000);
}

function showErrorOnEmail() {
  const stepError = document.querySelector(`.exp-form-step-4 .exp-form-error-message-email`);
  stepError.classList.remove('hidden-block');
  setTimeout(() => {
    stepError.classList.add('hidden-block');
  }, 15000);
}

async function handleCreateCoupon() {
  const couponInput = document.getElementById('expCoupon');
  const emailInput = document.getElementById('expEmail')
  try {
    if (couponInput.value && emailInput.value) {
      const createdCoupon = await fetch('/apps/proxy/caffeine-experts/create-coupon', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ coupon: couponInput.value, email: emailInput.value }),
      })
        .then((data) => data.json())
        .catch((err) => console.log(err));

      if (createdCoupon.data && createdCoupon.data.status === 200) {
        setExpFormStep(6)
        const progressBarElement = document.querySelector('.exp-form-progress-section')
        if (progressBarElement) progressBarElement.classList.add('hidden-block')
      }
    }
  } catch (err) {
    return showErrorBox(5)
  }
}
